import React, { useContext, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Checkbox, Spin } from "antd";
import { CheckboxValueType } from "antd/es/checkbox/Group";
import CustomEmpty from "../../../components/CourseComponents/CustomEmpty";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import MeetingListItem from "./Components/ListItem";
import useRequest from "../../../utils/useRequest";
import { CourseContext } from "../Store";
import { deleteMeeting, getMeetingList } from "../../../service/meeting";
import useModalHandler from "../../../utils/v2/useModalHandler";
import EditMeetingModal from "./Components/EditMeetingModal";
import useRequestFn from "../../../utils/useRequestFn";
import { ResultMessage } from "../../../components/ResultMessage";
import { errorMessage } from "../../../service/service";
import DeleteConfirm from "../../../components/DeleteConfirm";

const Index = () => {
    const { course } = useContext(CourseContext);
    const [data, { loading: getDataLoading }, reload] = useRequest(
        () => getMeetingList({ weekTimeId: course.weekTimeId }),
        {},
        [course]
    );
    const [select, setSelect] = useState<CheckboxValueType[]>([]);

    //编辑会议
    const editModal = useModalHandler(EditMeetingModal, { remove: true });
    function openEditModal(id: string | null) {
        editModal.open({ id });
    }
    function onEditSuccess() {
        editModal.close();
        reload();
    }

    const [deleteAction, { loading: delLoading }] = useRequestFn(deleteMeeting);
    async function onDelete(id: string) {
        try {
            await deleteAction({ id });
            await reload();
            setSelect([]);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }
    function deleteMany() {
        const id = select.join(",");
        onDelete(id);
    }

    const onCheckAllChange = (e: CheckboxChangeEvent) => {
        const plainOptions = data?.map(item => item.id);
        setSelect(e.target.checked ? plainOptions || [] : []);
    };

    const checkAll = useMemo(() => {
        return select.length === data?.length && select.length > 0;
    }, [select, data]);

    return (
        <div>
            <div className={style.header}>
                <div className={style.count}>会议活动（{data?.length}）</div>

                <div className={style.tools}>
                    <DeleteConfirm
                        title={`确定全部删除吗？`}
                        onSuccess={deleteMany}>
                        <Button
                            className={style.button}
                            disabled={select.length === 0}>
                            批量删除
                        </Button>
                    </DeleteConfirm>
                    <Button
                        className={style.button}
                        onClick={() => openEditModal(null)}
                        icon="plus-square">
                        创建会议
                    </Button>
                </div>
            </div>
            <Spin spinning={[getDataLoading, delLoading].some(i => i)}>
                <div className={style.main}>
                    <dl className={style.dl}>
                        <dt className={style.dt}>
                            <Checkbox
                                onChange={onCheckAllChange}
                                indeterminate={select.length > 0 && !checkAll}
                                checked={checkAll}
                            />
                        </dt>
                        <dd className={style.dd}>全选</dd>
                    </dl>
                    <Checkbox.Group
                        style={{ width: "100%" }}
                        value={select}
                        onChange={setSelect}>
                        {data?.map(item => (
                            <dl className={style.dl} key={item.id}>
                                <dt className={style.dt}>
                                    <Checkbox value={item.id} />
                                </dt>
                                <dd className={style.dd}>
                                    <MeetingListItem
                                        reload={reload}
                                        rowItem={item}
                                        onEdit={openEditModal}
                                        onDelete={onDelete}
                                    />
                                </dd>
                            </dl>
                        ))}
                    </Checkbox.Group>

                    {data?.length === 0 && (
                        <CustomEmpty style={{ padding: "100px 0" }} />
                    )}
                </div>
            </Spin>

            {editModal.render(<EditMeetingModal onSuccess={onEditSuccess} />)}
        </div>
    );
};

export default Index;
